<script lang="ts" setup>
  import type { Standing } from '../../../shared/api/player.ts';
  import { Cluster } from '../../../shared/ui/cluster';

  defineProps<{ standing: Standing }>();
</script>

<template>
  <header class="game-header">
    <Cluster class="stats" space="s">
      <div class="stat-item">
        <span class="label">Rank</span>
        <span class="value">#{{ standing.placement }}</span>
      </div>
      <div class="stat-item">
        <span class="label">Score</span>
        <span class="value">{{ standing.score }}</span>
      </div>
    </Cluster>

    <h1 class="nickname">{{ standing.player.nickname }}</h1>

    <div class="header-end">
      <slot />
    </div>
  </header>
</template>

<style scoped>
  .game-header {
    align-items: center;
    border-bottom: 2px solid var(--color-border-subtle);
    display: grid;
    gap: 0.5rem;
    grid-template-columns: 1fr minmax(0, auto) 1fr;
    min-height: 4.5rem;
    padding: 0.5rem var(--view-gutter);
    position: relative;
    width: 100%;
  }

  .header-end {
    display: flex;
    justify-content: flex-end;
  }

  .nickname {
    color: var(--color-primary);
    font-family: var(--font-nickname);
    font-size: var(--font-size-sm);
    margin: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .stat-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
  }

  .stat-item .label {
    color: var(--color-text-muted);
    font-size: var(--font-size-xs);
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .stat-item .value {
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-strong);
  }
</style>
